import React from "react";
import { RequestStatus } from "../types/request.types";
import { Badge } from "@mantine/core";

const statusColors = {
  'New': 'green',
  'Denied': 'red',
  'Approved': 'cyan',
  'Unapproved': 'orange',
  'In progress': 'blue',
  'Waiting for approval': 'yellow',
  'On Hold': 'gray',
  'At printer': 'violet',
  'Completed': 'black'
};

interface RequestStatusBadgeProps {
  status: RequestStatus;
  size?: string;
}

export default function RequestStatusBadge(
  { status, size = "md" }: RequestStatusBadgeProps
) {
  return (
    <Badge color={statusColors[status]} size={size}>
      {status}
    </Badge>
  );
}
